type Props = {
  image: string
  altImage: string
  title: string
  description: string
}

export const SystemCard = ({ image, altImage, title, description }: Props) => {
  return (
    <div className="h-52 flex flex-col items-start justify-between w-full border rounded-md p-4">
      <img src={image} alt={altImage} className="w-16" />
      <p className="text-base text-black font-semibold">{title}</p>
      <p className="text-base text-black">{description}</p>
    </div>
  )
}
